import {useState} from 'react'

import styles from './ProjectItemSection.module.css'
import {ProjectItemSectionFieldList} from './ProjectItemSectionFieldList'
import type {ProjectItemSectionViewFragment} from './ProjectItemSectionView'
import {ProjectItemSectionView} from './ProjectItemSectionView'

export type ProjectItemSectionProps = {
  projectItem: ProjectItemSectionViewFragment
  isOpen: boolean
  onIssueUpdate: () => void
  isProjectClosed: boolean
}

export function ProjectItemSection({
  projectItem: data,
  onIssueUpdate,
  isOpen = false,
  isProjectClosed,
}: ProjectItemSectionProps) {
  const [open, setOpen] = useState(isOpen)

  return (
    <div className={styles.ProjectItemSectionContainer}>
      <ProjectItemSectionView
        projectItem={data}
        open={open}
        setOpen={setOpen}
        onIssueUpdate={onIssueUpdate}
        isSelectedProject={isOpen}
        isProjectClosed={isProjectClosed}
      />
      {open && (
        <ProjectItemSectionFieldList
          projectItemId={data.id}
          projectId={data.project.id}
          isArchived={data.isArchived}
          onIssueUpdate={onIssueUpdate}
        />
      )}
    </div>
  )
}
